import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import Header from '../components/Header.jsx';
import Seo from '../components/Seo.jsx';
import { Eyebrow } from '../components/Section.jsx';
import { formatReviewDate, getLiveGuides } from '../lib/guides.js';

// The evergreen index: the decisions a Charleston trip starts with. The daily
// brief owns "today"; these pages own the questions that don't change much.

export default function Guides() {
  const live = getLiveGuides();
  return (
    <div className="mx-auto max-w-brief px-4 pt-6 sm:px-6">
      <Seo
        title="Charleston Trip Guides · Charleston.Vacations"
        description="Evergreen guides to the decisions every Charleston trip starts with: where to stay, which beach, what to do with kids. Written by the people behind the daily brief."
      />
      <Header />
      <div className="mt-8 border-b border-navy-100 pb-6">
        <Eyebrow text="The evergreen shelf" />
        <h1 className="mt-2 font-display text-3xl font-semibold text-navy-900 sm:text-4xl">
          Charleston Trip Guides
        </h1>
        <p className="mt-3 leading-relaxed text-navy-700">
          The daily brief answers what today is good for. These guides answer the
          questions you settle before you arrive: where to stay, which beach,
          how to run a downtown day. They only change when the facts do.
        </p>
      </div>

      {live.length ? (
        <ul>
          {live.map((g) => (
            <li key={g.slug} className="border-b border-navy-100 py-6">
              <Link to={`/guides/${g.slug}`} className="group block no-underline">
                <h2 className="font-display text-xl font-semibold text-navy-900 group-hover:underline sm:text-2xl">
                  {g.title}
                </h2>
                <p className="mt-2 leading-relaxed text-navy-700">{g.summary}</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-navy-500">
                  Last reviewed {formatReviewDate(g.lastReviewed)}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="py-6 leading-relaxed text-navy-700">
          The first guides are being written now. Until they land,{' '}
          <Link to="/" className="text-navy-900 underline">
            today's brief
          </Link>{' '}
          is the read.
        </p>
      )}
      <Footer />
    </div>
  );
}
